import { Box } from '@mui/material';
import { ChartCard } from '../components/Cards/ChartCard';
import { usePatientCharts } from './hooks/usePatientCharts';
import { BarChart } from '../components/Charts/BarChart';
import { SortByActionButton } from '@components';
import { theme } from '@store';

export const PatientCharts = () => {
  const {
    hasViewPermission,
    assignedPatients,
    uniquePatientUpdates,
    careNotesAdded,
    carePlansUpdated,
    patientChartSortByKey,
    handleChangeSortByKey,
    isLoadingAssigned,
    isLoadingUnique,
    isLoadingCareNotes,
    isLoadingCarePlan,
  } = usePatientCharts();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `1fr 1fr`,
        gap: 2,
        [theme.breakpoints.down('lg')]: {
          gridTemplateColumns: `1fr`,
        },
      }}
    >
      <ChartCard
        title='Assigned patients'
        report_id={assignedPatients?.linked_report_id}
        hideButton={!hasViewPermission}
        isLoading={isLoadingAssigned}
        actionButton={
          <SortByActionButton
            order={patientChartSortByKey['assigned']}
            onClick={() => handleChangeSortByKey('assigned')}
          />
        }
      >
        <BarChart
          report_id={assignedPatients?.linked_report_id}
          entries={
            assignedPatients?.data.map(o => ({
              'Patient count': o.value,
              label: o.name,
            })) ?? []
          }
          total={assignedPatients?.total}
        />
      </ChartCard>

      <ChartCard
        title='Unique patient updates'
        report_id={uniquePatientUpdates?.linked_report_id}
        hideButton={!hasViewPermission}
        isLoading={isLoadingUnique}
        actionButton={
          <SortByActionButton
            order={patientChartSortByKey['unique']}
            onClick={() => handleChangeSortByKey('unique')}
          />
        }
      >
        <BarChart
          report_id={uniquePatientUpdates?.linked_report_id}
          entries={
            uniquePatientUpdates?.data.map(o => ({
              'Patient count': o.value,
              label: o.name,
            })) ?? []
          }
          total={uniquePatientUpdates?.total}
        />
      </ChartCard>

      <ChartCard
        title='Care notes added'
        report_id={careNotesAdded?.linked_report_id}
        hideButton={!hasViewPermission}
        isLoading={isLoadingCareNotes}
        actionButton={
          <SortByActionButton
            order={patientChartSortByKey['careNotes']}
            onClick={() => handleChangeSortByKey('careNotes')}
          />
        }
      >
        <BarChart
          report_id={careNotesAdded?.linked_report_id}
          entries={
            careNotesAdded?.data.map(o => ({
              'Patient count': o.value,
              label: o.name,
            })) ?? []
          }
          total={careNotesAdded?.total}
        />
      </ChartCard>

      <ChartCard
        title='Care plans updated'
        report_id={carePlansUpdated?.linked_report_id}
        hideButton={!hasViewPermission}
        isLoading={isLoadingCarePlan}
        actionButton={
          <SortByActionButton
            order={patientChartSortByKey['carePlan']}
            onClick={() => handleChangeSortByKey('carePlan')}
          />
        }
      >
        <BarChart
          report_id={carePlansUpdated?.linked_report_id}
          entries={
            carePlansUpdated?.data.map(o => ({
              'Patient count': o.value,
              label: o.name,
            })) ?? []
          }
          total={carePlansUpdated?.total}
        />
      </ChartCard>
    </Box>
  );
};
